import { useMemo } from 'react';

import { ServiceContract } from '@work4all/models/lib/Classes/ServiceContract.entity';
import { DataRequest } from '@work4all/models/lib/DataProvider';
import { EMode } from '@work4all/models/lib/Enums/EMode.enum';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { CUSTOM_FIELDS_DATA } from '../../../components/custom-fields/custom-fields-data';

export const useServiceContractRequestData = (id: string | number) => {
  return useMemo<DataRequest>(() => {
    const filter = [{ id: { $eq: id } }];
    const entity = Entities.serviceContract;
    const data: ServiceContract<EMode.query> = {
      // Basic information
      id: null,
      number: null,
      name: null,
      addition: null,
      note: null,

      // Contract fields
      serviceContractDeductionKind: null,
      kindLookupId: null,
      typeOfContract: {
        id: null,
        name: null,
      },
      contractId: null,
      contract: {
        id: null,
        note: null,
        number: null,
      },
      serviceContractStartDate: null,
      serviceContractEndDate: null,
      nextInvoiceDate: null,
      terminationDate: null,
      permanentInvoice: null,
      rythm: null,

      // Financial information
      amount: null,
      priceTotal: null,
      singlePriceTotal: null,
      skonto: null,
      skontoDurationDays: null,
      paymentId: null,
      paymentKind: {
        id: null,
        longtext: null,
        note: null,
        skonto1DurationDays: null,
        skonto1Percent: null,
      },
      paymentDeadline: null,
      costCenterId: null,
      languageId: null,
      priceGroupId: null,
      priceGroup: {
        id: null,
        name: null,
      },

      // Project information
      project: {
        id: null,
        name: null,
        number: null,
      },
      projectId: null,

      // Group information
      group: {
        name: null,
        id: null,
      },
      groupId: null,

      // Participants information
      mainAddress: {
        businessPartner: {
          id: null,
          data: {
            customer: {
              id: null,
              name: null,
              website: null,
              number: null,
              extinct: null,
              mainContact: {
                id: null,
                name: null,
                firstName: null,
                displayName: null,
              },
              isPrivateCustomer: null,
              language: {
                id: null,
                name: null,
              },
            },
            supplier: {
              id: null,
              name: null,
              website: null,
              number: null,
              extinct: null,
              mainContact: {
                id: null,
                name: null,
                firstName: null,
                displayName: null,
              },
              isPrivateCustomer: null,
              language: {
                id: null,
                name: null,
              },
            },
          },
        },
        contact: {
          id: null,
          name: null,
          firstName: null,
          displayName: null,
        },
      },
      mainAddressSdObjMemberId: null,
      mainAddressDepartmentId: null,
      mainAddressContactId: null,

      endCustomerContactId: null,
      endCustomerSdObjMemberId: null,
      endCustomer: {
        businessPartner: {
          id: null,
          data: {
            customer: {
              id: null,
              name: null,
              website: null,
              number: null,
              extinct: null,
              mainContact: {
                id: null,
                name: null,
                firstName: null,
                displayName: null,
              },
              isPrivateCustomer: null,
            },
            supplier: {
              id: null,
              name: null,
              website: null,
              number: null,
              extinct: null,
              mainContact: {
                id: null,
                name: null,
                firstName: null,
                displayName: null,
              },
              isPrivateCustomer: null,
            },
          },
        },
        contact: {
          id: null,
          name: null,
          firstName: null,
          displayName: null,
        },
      },
      deliveryAddress: {
        businessPartner: {
          id: null,
          data: {
            customer: {
              id: null,
              name: null,
              website: null,
              number: null,
              extinct: null,
              mainContact: {
                id: null,
                name: null,
                firstName: null,
                displayName: null,
              },
              isPrivateCustomer: null,
            },
            supplier: {
              id: null,
              name: null,
              website: null,
              number: null,
              extinct: null,
              mainContact: {
                id: null,
                name: null,
                firstName: null,
                displayName: null,
              },
              isPrivateCustomer: null,
            },
          },
        },
        contact: {
          id: null,
          name: null,
          firstName: null,
          displayName: null,
        },
      },
      deliveryAddressContactId: null,
      deliveryAddressDepartmentId: null,
      deliveryAddressSdObjMemberId: null,
      additionalAddress2ContactId: null,
      additionalAddress2DepartmentId: null,
      additionalAddress2SdObjMemberId: null,

      // Positions
      positionList: [
        {
          id: null,
          number: null,
          longtext: null,
          amountDecimal: null,
          positionKind: null,
          article: {
            id: null,
            longtext: null,
            unit: {
              id: null,
              name: null,
            },
          },
        },
      ],

      customFieldList: [CUSTOM_FIELDS_DATA],

      // Timestamps and user information
      creationDate: null,
      insertTime: null,
      updateTime: null,
      creatorUserId: null,
    };
    return { filter, entity, data };
  }, [id]);
};
